import { getRemoteConfigInstance } from "./firebase.js"
import { getString } from "firebase/remote-config";

export const getRCString = async (param) => {
    const remoteInstance = getRemoteConfigInstance()
    
    return getString(remoteInstance, param)
}